import React, { useEffect, useState } from 'react';
import { Flex, Text, Button, Icon, Heading } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { FaGhost } from 'react-icons/fa';
import { track } from '../utils/umami';

function BouncingGhostIcon() {
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    let startTime = null;
    let rafId;

    const animate = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = timestamp - startTime;
      // Adjust the numbers below to control speed & amplitude
      const y = Math.sin(progress / 300) * 10;
      setOffset(y);

      rafId = requestAnimationFrame(animate);
    };

    rafId = requestAnimationFrame(animate);

    return () => cancelAnimationFrame(rafId);
  }, []);

  return (
    <Icon
      as={FaGhost}
      boxSize={20}
      color="yellow.400"
      mb={4}
      mt={-6}
      // We apply the vertical “bounce” here
      style={{ transform: `translateY(${offset}px)` }}
    />
  );
}

export default function EventNotFound() {
  useEffect(() => {
    track.pageNotFound({ tipo: 'evento' });
  }, []);

  return (
    <Flex
      direction="column"
      align="center"
      justify="center"
      textAlign="center"
      minH="500px"
      borderRadius="md"
      bg="whiteAlpha.700"
      px={4}
      mt={4}
      mr={4}
      ml={4}
    >
      <BouncingGhostIcon />
      <Heading as="h1" size="lg" mb={2} mt={3} color="blue.600">
        Evento non disponibile
      </Heading>
      <Text fontSize="lg" mb={6} color="blue.500">
        Sembra che l&apos;evento che stavi cercando non sia più disponibile.
      </Text>
      <Button as={Link} to="/attivita" colorScheme="blue" size="lg" px={8}>
        Torna alle attività
      </Button>
    </Flex>
  );
}
